var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            direction: "rtl",
            "show-close": false,
            "wrapper-closable": true,
            "append-to-body": true,
            wrapperClosable: _vm.type == "edit" ? false : true,
            size: "55%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "title flex-between",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("div", [_vm._v(_vm._s(_vm.name || "查看"))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "title-right" },
                [
                  _vm.dropdownList && _vm.dropdownList.length > 0
                    ? _c(
                        "el-dropdown",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "mr10",
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-plus",
                              },
                            },
                            [_vm._v("新增相关")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-menu",
                            { staticStyle: { "text-align": "left" } },
                            _vm._l(_vm.dropdownList, function (item) {
                              return _c(
                                "el-dropdown-item",
                                {
                                  key: item.id,
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.dropdownSearch(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              新建" +
                                      _vm._s(item.table_name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-dropdown",
                    [
                      _c("div", { staticClass: "close-box mr10" }, [
                        _c("span", { staticClass: "el-icon-more" }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { staticStyle: { "text-align": "left" } },
                        [
                          _vm.tabIndex == 1
                            ? _c(
                                "el-dropdown-item",
                                {
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.editRow($event)
                                    },
                                  },
                                },
                                [_vm._v(" 编辑 ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.tabIndex == 1
                            ? _c(
                                "el-dropdown-item",
                                {
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.deleteRow($event)
                                    },
                                  },
                                },
                                [_vm._v(" 删除 ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                divided: _vm.tabIndex == 1 ? true : false,
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openCheck()
                                },
                              },
                            },
                            [_vm._v("\n              配置新建项\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.openCheck("tab")
                                },
                              },
                            },
                            [_vm._v(" 配置tab显示项 ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "close-box no-border",
                      on: { click: _vm.handleClose },
                    },
                    [_c("span", { staticClass: "el-icon-close" })]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card", "tab-position": "top" },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.tabIndex,
                    callback: function ($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { label: "详情", name: "1" } }),
                  _vm._v(" "),
                  _vm._l(_vm.tabData, function (item) {
                    return _c("el-tab-pane", {
                      key: item.table_name_en,
                      attrs: {
                        label: item.table_name,
                        name: item.table_name_en,
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tabIndex == 1
            ? _c(
                "div",
                { staticClass: "mt50" },
                [
                  _vm.drawer
                    ? _c("VFormRender", {
                        ref: "preForm",
                        attrs: {
                          "form-json": _vm.importTemplate,
                          "form-data": _vm.allocation.module_info,
                          "preview-state": true,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "edit"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "button from-foot-btn fix btn-shadow mt30",
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "el-btn",
                              attrs: { size: "small" },
                              on: { click: _vm.setForm },
                            },
                            [_vm._v("取消")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.saveFn()
                                },
                              },
                            },
                            [_vm._v("保存")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabIndex != 1
            ? _c(
                "div",
                { staticClass: "mt50 table-box" },
                [
                  _c(
                    "div",
                    { staticClass: "flex-between mb10" },
                    [
                      _c(
                        "div",
                        { staticClass: "search" },
                        [
                          _c("div", { staticClass: "inTotal" }, [
                            _vm._v("共 " + _vm._s(_vm.total) + " 项"),
                          ]),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "input",
                            attrs: {
                              "prefix-icon": "el-icon-search",
                              size: "small",
                              placeholder: "请输入关键字",
                              clearable: "",
                            },
                            on: { change: _vm.getList },
                            model: {
                              value: _vm.where.keyword_default,
                              callback: function ($$v) {
                                _vm.$set(_vm.where, "keyword_default", $$v)
                              },
                              expression: "where.keyword_default",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            icon: "el-icon-plus",
                            type: "primary",
                          },
                          on: { click: _vm.addData },
                        },
                        [_vm._v("新建" + _vm._s(_vm.getName))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData, "row-key": "id" },
                    },
                    [
                      _vm._l(_vm.tabInfo.showField, function (item, index) {
                        return _c("el-table-column", {
                          key: index,
                          attrs: {
                            prop: item.field_name_en,
                            label: item.field_name,
                            width: "auto",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    item.form_value === "image"
                                      ? _c(
                                          "div",
                                          { staticClass: "img-box" },
                                          [
                                            _vm._l(
                                              scope.row[item.field_name_en],
                                              function (val, index) {
                                                return _c("img", {
                                                  key: index,
                                                  staticClass: "img",
                                                  attrs: {
                                                    src: val.url,
                                                    alt: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.lookViewer(
                                                        val.url,
                                                        val.name
                                                      )
                                                    },
                                                  },
                                                })
                                              }
                                            ),
                                            _vm._v(" "),
                                            !scope.row[item.field_name_en] ||
                                            scope.row[item.field_name_en]
                                              .length == 0
                                              ? _c("span", [_vm._v("--")])
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      : item.form_value === "file"
                                      ? _c(
                                          "div",
                                          [
                                            _vm.normalizeCrudFiles(
                                              scope.row[item.field_name_en]
                                            ).length
                                              ? _vm._l(
                                                  _vm.normalizeCrudFiles(
                                                    scope.row[
                                                      item.field_name_en
                                                    ]
                                                  ),
                                                  function (val, fIdx) {
                                                    return _c(
                                                      "el-button",
                                                      {
                                                        key: "f_" + fIdx,
                                                        attrs: { type: "text" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.downloadCrudFile(
                                                              val
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("下载文件")]
                                                    )
                                                  }
                                                )
                                              : _c("span", [_vm._v("--")]),
                                          ],
                                          2
                                        )
                                      : item.form_value === "input_percentage"
                                      ? _c(
                                          "div",
                                          [
                                            _c("el-progress", {
                                              attrs: {
                                                percentage: scope.row[
                                                  item.field_name_en
                                                ]
                                                  ? scope.row[
                                                      item.field_name_en
                                                    ]
                                                  : 0,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : item.form_value === "tag" ||
                                        item.form_value === "checkbox"
                                      ? _c(
                                          "div",
                                          [
                                            scope.row[item.field_name_en] &&
                                            scope.row[item.field_name_en]
                                              .length > 2
                                              ? _c(
                                                  "el-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top-start",
                                                      trigger: "hover",
                                                    },
                                                  },
                                                  [
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flex_box",
                                                        },
                                                        _vm._l(
                                                          scope.row[
                                                            item.field_name_en
                                                          ],
                                                          function (
                                                            val,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "tips",
                                                              },
                                                              [
                                                                _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      size: "small",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                        " +
                                                                        _vm._s(
                                                                          val
                                                                        ) +
                                                                        "\n                      "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ],
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "reference",
                                                        },
                                                        slot: "reference",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex_box",
                                                          },
                                                          [
                                                            _vm._l(
                                                              scope.row[
                                                                item
                                                                  .field_name_en
                                                              ],
                                                              function (
                                                                val,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: index,
                                                                    staticClass:
                                                                      "tips",
                                                                  },
                                                                  [
                                                                    index < 2
                                                                      ? _c(
                                                                          "el-tag",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                size: "small",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                        " +
                                                                                _vm._s(
                                                                                  val
                                                                                ) +
                                                                                "\n                      "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            scope.row[
                                                              item.field_name_en
                                                            ] &&
                                                            scope.row[
                                                              item.field_name_en
                                                            ].length > 2
                                                              ? _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      size: "small",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "..."
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex_box" },
                                                    [
                                                      _vm._l(
                                                        scope.row[
                                                          item.field_name_en
                                                        ],
                                                        function (val, index) {
                                                          return _c(
                                                            "div",
                                                            {
                                                              key: index,
                                                              staticClass:
                                                                "tips",
                                                            },
                                                            [
                                                              index < 2
                                                                ? _c(
                                                                    "el-tag",
                                                                    {
                                                                      attrs: {
                                                                        size: "small",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                      " +
                                                                          _vm._s(
                                                                            val
                                                                          ) +
                                                                          "\n                    "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      scope.row[
                                                        item.field_name_en
                                                      ] &&
                                                      scope.row[
                                                        item.field_name_en
                                                      ].length > 2
                                                        ? _c(
                                                            "el-tag",
                                                            {
                                                              attrs: {
                                                                size: "small",
                                                              },
                                                            },
                                                            [_vm._v("...")]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                            _vm._v(" "),
                                            !scope.row[item.field_name_en] ||
                                            scope.row[item.field_name_en]
                                              .length == 0
                                              ? _c("span", [_vm._v("--")])
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      : item.form_value === "switch"
                                      ? _c(
                                          "div",
                                          [
                                            _c("el-switch", {
                                              attrs: {
                                                disabled: "",
                                                "active-value": 1,
                                                "inactive-value": 0,
                                                "active-text": "开启",
                                                "inactive-text": "关闭",
                                              },
                                              model: {
                                                value:
                                                  scope.row[item.field_name_en],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    item.field_name_en,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row[item.field_name_en]",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : item.form_value === "textarea"
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "el-popover",
                                              {
                                                attrs: {
                                                  placement: "top-start",
                                                  width: "350",
                                                  trigger: "hover",
                                                  content:
                                                    scope.row[
                                                      item.field_name_en
                                                    ],
                                                },
                                              },
                                              [
                                                scope.row[item.field_name_en] &&
                                                scope.row[item.field_name_en]
                                                  .length > 11
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "over-text",
                                                        attrs: {
                                                          slot: "reference",
                                                        },
                                                        slot: "reference",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  " +
                                                            _vm._s(
                                                              scope.row[
                                                                item
                                                                  .field_name_en
                                                              ]
                                                            ) +
                                                            "\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            scope.row[item.field_name_en] &&
                                            scope.row[item.field_name_en]
                                              .length <= 11
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        scope.row[
                                                          item.field_name_en
                                                        ]
                                                      ) +
                                                      "\n              "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !scope.row[item.field_name_en]
                                              ? _c("span", [_vm._v("--")])
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      : [
                                          "input_number",
                                          "input_float",
                                          "input_price",
                                        ].includes(item.form_value)
                                      ? _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                scope.row[item.field_name_en]
                                              ) +
                                              "\n            "
                                          ),
                                        ])
                                      : _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.getValue(
                                                  scope.row[item.field_name_en]
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "address",
                          label: "操作",
                          fixed: "right",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editTabsRow(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteTabsRow(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4203223062
                        ),
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex-end mt14" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          "page-size": _vm.where.limit,
                          "current-page": _vm.where.page,
                          layout: "total, prev, pager, next, jumper",
                          total: _vm.total,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("add-drawer", {
        ref: "addDrawer",
        attrs: { keyName: _vm.tabKey, crud: _vm.crud },
        on: { getList: _vm.getList },
      }),
      _vm._v(" "),
      _c("checkbox-dialog", {
        ref: "checkboxDialog",
        attrs: {
          title: _vm.title,
          type: "field",
          name: "所有关联实体",
          showName: "已展示实体",
        },
        on: { getData: _vm.getData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }